import React from 'react';

// Dopo un deploy i vecchi chunk non esistono più: chi ha la pagina aperta
// (o un index.html in cache) prova a caricarli e fallisce. In quel caso
// ricarichiamo una volta sola per prendere il bundle nuovo.
const CHIAVE_RELOAD = 'psc_chunk_reload';

export const isChunkLoadError = (error) =>
    !!error && (error.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(error.message || ''));

export const ricaricaPerChunkMancante = () => {
    try {
        const ultimo = Number(sessionStorage.getItem(CHIAVE_RELOAD) || 0);
        if (Date.now() - ultimo < 30000) return false; // evita loop di reload
        sessionStorage.setItem(CHIAVE_RELOAD, String(Date.now()));
    } catch (e) { /* storage non disponibile: ricarichiamo comunque una volta */ }
    window.location.reload();
    return true;
};

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        if (isChunkLoadError(error) && ricaricaPerChunkMancante()) return;
        console.error('ErrorBoundary:', error, info.componentStack);
    }

    handleReset = () => {
        if (isChunkLoadError(this.state.error)) {
            window.location.reload();
            return;
        }
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center p-5 text-center">
                    <i className="fas fa-triangle-exclamation fa-3x text-warning mb-3" />
                    <h5 className="mb-2">Si è verificato un errore imprevisto</h5>
                    <p className="text-muted small mb-3">
                        {isChunkLoadError(this.state.error)
                            ? 'È disponibile una nuova versione di PSC. Ricarica la pagina per continuare.'
                            : (this.state.error?.message || 'Errore sconosciuto')}
                    </p>
                    <button className="btn btn-outline-primary btn-sm" onClick={this.handleReset}>
                        {isChunkLoadError(this.state.error) ? 'Ricarica' : 'Riprova'}
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
